import { useState, useEffect } from 'react';

/**
 * Custom hook to fetch and manage project data.
 *
 * @param {string} apiUrl - The API endpoint URL.
 * @returns {Object} - { projects, center, domain, cities, neighborhoods, companies, loading, error }
 */
function useProjects(apiUrl) {
  const [projects, setProjects] = useState([]);
  const [center, setCenter] = useState({ lat: 34.0522, lon: -118.2437 });
  const [domain, setDomain] = useState(null);
  const [cities, setCities] = useState({});
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!apiUrl) {
      setError('No API URL provided');
      setLoading(false);
      return;
    }

    const fetchProjects = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(apiUrl, {
          headers: {
            'Accept': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        setProjects(data.projects || []);
        if (data.center) {
          setCenter(data.center);
        }
        if (data.domain) {
          setDomain(data.domain);
        }
        if (data.cities) {
          setCities(data.cities);
        }
        if (data.neighborhoods) {
          setNeighborhoods(data.neighborhoods);
        }
        if (data.companies) {
          setCompanies(data.companies);
        }
      } catch (err) {
        console.error('Error fetching projects:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [apiUrl]);

  return { projects, center, domain, cities, neighborhoods, companies, loading, error };
}

export default useProjects;
